import { render, staticRenderFns } from "./HomeNewsCard.vue?vue&type=template&id=0dda8705"
import script from "./HomeNewsCard.vue?vue&type=script&lang=js"
export * from "./HomeNewsCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports